<script setup>
import AlertDanger from '@shared-components/ui/alerts/AlertDanger.vue'
import {defineEmits} from 'vue'
import {storeToRefs} from 'pinia'
import {useAuthenticationStore} from '@/stores'

const {canUseInvoices} = storeToRefs(useAuthenticationStore())

let emit = defineEmits(['open-invoice-modal'])

const openInvoiceModal = () => {
  emit('open-invoice-modal')
}
</script>

<template>
  <alert-danger class="fs-13-px">
    <div class="fw-bold">Oops! You’re exceeding the allowed top-up limit.</div>
    <div>You can only top-up 95% of your available funds – the rest covers platform fees.</div>
    <div class="text-dark">
      Enter a lower amount to proceed
      <span v-if="canUseInvoices">
        or
        <span class="link-info link-default-decoration fw-bold pointer" @click="openInvoiceModal">Top-Up Balance</span>
        now</span
      >.
    </div>
  </alert-danger>
</template>
